/**
 * Footer link data sourced from @covestro-cx/design-library-translations.
 * Link href and external flag must stay in sync with FooterLinkKey in the library.
 */
import {footerLinks, type FooterLinkKey} from '@covestro-cx/design-library-translations';

/** Represents a single footer link with its translation key, URL, and target behavior. */
export interface FooterLink {
  /** Translation key used with Transloco to render the link label. */
  key: string;
  /** URL the link navigates to — either relative (internal) or absolute (external). */
  href: string;
  /** Whether the link opens in a new tab (external site) or same window (internal route). */
  external: boolean;
}

function toLink(key: FooterLinkKey): FooterLink {
  const entry = footerLinks[key];
  if (!entry) {
    throw new Error(`Missing footer link: ${key}`);
  }
  return {key, href: entry.href, external: entry.external};
}

/** Legal links displayed in the first footer column. */
export const FOOTER_LEGAL_LINKS: FooterLink[] = [
  toLink('footer.legal.privacyStatement'),
  toLink('footer.legal.conditionsOfUse'),
  toLink('footer.legal.imprint'),
  toLink('footer.legal.salesConditions'),
  toLink('footer.legal.californiaDoNotTrackDisclosure'),
];

/** Covestro corporate links displayed in the second footer column. */
export const FOOTER_COVESTRO_LINKS: FooterLink[] = [
  toLink('footer.covestro.global'),
  toLink('footer.covestro.solutionCenter'),
  toLink('footer.covestro.aboutUs'),
];

/** Tank Farm Assessment link — conditionally shown based on user permissions. */
export const FOOTER_COVESTRO_TANK_FARM: FooterLink = toLink('footer.covestro.tankFarmAssessment');

/** Contact links displayed in the third footer column. */
export const FOOTER_CONTACT_LINKS: FooterLink[] = [
  toLink('footer.contact.contactUs'),
  toLink('footer.contact.productSafetyFirst'),
];
